import ReactDOM from 'react-dom/client';
import routes from '../routes';

ReactDOM
    .createRoot(document.getElementById("reactContent"))
    .render(routes);
